import type { InferInsertModel, InferSelectModel } from 'drizzle-orm';
import {
  boolean,
  doublePrecision,
  pgTable,
  text,
  timestamp,
  uuid,
} from 'drizzle-orm/pg-core';

export const companies = pgTable('companies', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  cnpj: text('cnpj').notNull().unique(),
  corporateName: text('corporate_name').notNull(),
  tradeName: text('trade_name').notNull(),
  prefix: text('prefix').notNull(),
  logo: text('logo'),
  nextSaleNumber: doublePrecision('next_sale_number').default(1),
  isActive: boolean('is_active').default(true),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
});

export type Company = InferSelectModel<typeof companies>;
export type CreateCompanyInput = InferInsertModel<typeof companies>;
export type UpdateCompanyInput = Partial<CreateCompanyInput>;
